import React from 'react';

import { CheckoutLayoutBlock, TipsGroup } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import { useCheckoutContext } from '../../../../CheckoutProvider';
import { useCheckoutTips } from '../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const ConnectedCheckoutDeliveryTipBlock = () => {
  const { t } = useLocalizationContext();

  const { payload, handleDeliveryTip } = useCheckoutContext();
  const { tips, orderSubtotal } = useCheckoutTips();

  const selectedTipAmount = payload?.deliveryOrderDetail?.tip ?? 0;
  // ─────────────────────────────────────────────

  return (
    <CheckoutLayoutBlock>
      <TipsGroup
        defaultTipValue={tips[1].value}
        tips={tips}
        selectedTipAmountInCents={selectedTipAmount}
        setTipAmount={handleDeliveryTip}
        orderSubtotalInCents={orderSubtotal}
        sectionTitle={t('checkout.tips.delivery-tip.title')}
        sectionDescription={t('checkout.tips.delivery-tip.description')}
      />
    </CheckoutLayoutBlock>
  );
};
